import { types } from 'mobx-state-tree'

const Vec3 = types.array(types.number)

export default Vec3
